import type {
    TransportTrackMonitorAdjacentVo,
    TransportTrackMonitorMapVo,
    TransportTrackMonitorPage,
    TransportTrackMonitorQuery,
    TransportTrackMonitorVo
} from "@/api/transportTrackMonitorTypes";
import httpRequest from "./index";

const MONITOR_PATH = "/transport-track/monitor";
const MONITOR_PAGING_TIMEOUT = 60000;

/**
 * 砂石端在途监管接口。
 * 请求沿用项目 `/custom` baseURL，由 zhihaoscm-server 代理到 shipping。
 */
class TransportTrackMonitorService {
    /** 分页查询当前服务船运单的可见抓拍记录。 */
    async paging(params: TransportTrackMonitorQuery): Promise<TransportTrackMonitorPage> {
        const { data } = await httpRequest.get(`${MONITOR_PATH}/paging`, {
            params,
            timeout: MONITOR_PAGING_TIMEOUT,
            silentError: true
        });
        return data;
    }

    /** 查询地图抓拍点、航迹和船舶位置。 */
    async getMap(
        transportOrderShipId: string,
        params: Omit<TransportTrackMonitorQuery, "transportOrderShipId" | "page" | "size">
    ): Promise<TransportTrackMonitorMapVo> {
        const { data } = await httpRequest.get(`${MONITOR_PATH}/map/${transportOrderShipId}`, {
            params,
            silentError: true
        });
        return data;
    }

    /** 查询当前抓拍及完整筛选集合中的相邻抓拍。 */
    async getAdjacent(
        id: string,
        params: Omit<TransportTrackMonitorQuery, "page" | "size">
    ): Promise<TransportTrackMonitorAdjacentVo<TransportTrackMonitorVo>> {
        const { data } = await httpRequest.get(`${MONITOR_PATH}/adjacent/${id}`, {
            params,
            silentError: true
        });
        return data;
    }
}

export const transportTrackMonitorService = new TransportTrackMonitorService();
